import Send from '@/config/api/index'

const gitPath = "/v1/gitlab"
const postConfig = {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 1800000
}

function gitApi(api, params, config = null) {
    return Send.post(gitPath + api, params, config)
}

export default {
    mrList(params) {
        return gitApi('/mr', params)
    },
    projectDetails(params, config) {
        return gitApi('/project/details', params, config)
    },
    mrCount() {
        return gitApi('/mr/poll')
    },
    pjList(params) {
        return gitApi('/pjs', params)
    },
    pj(pjId) {
        return gitApi('/pj', pjId)
    },
    brc(projectIdOrName) {
        return gitApi('/brc', projectIdOrName)
    },
    createMR(params) {
        return gitApi('/mr/create', params)
    },
    uploadFile(pjId, file) {
        let formData = new FormData();
        formData.append('file', file)
        return gitApi('/mr/upload/' + pjId, formData, postConfig)
    },
    acceptMR(params) {
        return gitApi('/mr/accept', params)
    },
    cancelMR(params) {
        return gitApi('/mr/accept/cancel', params)
    },
    closeMR(params) {
        return gitApi('/mr/close', params)
    },
    deleteMR(params) {
        return gitApi('/mr/delete', params)
    },
    addTag(params) {
        return gitApi('/tag/add', params)
    },
    commits(params) {
        return gitApi('/commits', params)
    },
    tags(params, config) {
        return gitApi('/tags', params, config)
    },
    pipelineStatus(params) {
        return gitApi('/pipe/status', params)
    },
    createPJ(params) {
        return gitApi('/pj/create', params)
    },
    createBrc(params) {
        return gitApi('/brc/create', params)
    },
    retryPL(params) {
        return gitApi('/pl/re', params)
    },
    pipelineTrace(params, config) {
        return gitApi('/pl/trace', params, config)
    },
    getRawFile(params) {
        return gitApi('/rep/rawfile', params)
    }
}
